// extracted by mini-css-extract-plugin
module.exports = {"navigation":"W_cP","light":"W_s","principal":"W_cQ","elements":"W_cR","lessTwo":"W_cS","active":"W_S","hidden":"W_0"};